import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var sliceStackLines = function sliceStackLines() {
  var stack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var lines = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return stack.split('\n').slice(0, lines + 1).join('\n');
};
export var SilentMappingException = /*#__PURE__*/function (_Error) {
  _inherits(SilentMappingException, _Error);
  var _super = _createSuper(SilentMappingException);
  /**
   * Флаг используется в FriendlyErrorOverlayWebpackPlugin
   * Чтобы не выкидывать ошибку в overlay
   */

  function SilentMappingException(message) {
    var _options$stack;
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, SilentMappingException);
    _this = _super.call(this, message, options);
    /**
     * Данная ошибка вылетает довольно часто, и даже одна строчка stacktrace'а
     * убивает CPU из-за парсинга sourcemap'ов внутри ErrorOverlayPlugin'а
     */
    _defineProperty(_assertThisInitialized(_this), "silent", true);
    _this.stack = sliceStackLines((_options$stack = options.stack) !== null && _options$stack !== void 0 ? _options$stack : _this.stack);
    return _this;
  }
  return _createClass(SilentMappingException);
}( /*#__PURE__*/_wrapNativeSuper(Error));